import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import CertonaZone from '../CertonaZone/CertonaZone';
import productCartridgeActions from '../../actions/ProductCartridgeAction';

class CertonaZoneIris extends PureComponent {
    static defaultProps = {
        taxonomyData: {},
        slotDetails: {},
        schemasToRender: '',
    };

    static propTypes = {
        taxonomyData: PropTypes.object,
        slotDetails: PropTypes.object,
        schemasToRender: PropTypes.string,
        actions: PropTypes.object.isRequired,
    };

    componentWillMount() {
        const { schemasToRender, actions } = this.props;

        if (schemasToRender) {
            actions.addCertonaOptions(schemasToRender);
        }
    }

    render() {
        const { taxonomyData } = this.props;
        const { slotDetails } = this.props;
        const breadCrumbInfo = taxonomyData.breadcrumbsData;

        // only if the data is available then set
        if (breadCrumbInfo) {
            /** Looping Breadcrumb to add the certona options */
            breadCrumbInfo.forEach((breadCrumb) => {
                if (breadCrumb.catId) {
                    slotDetails.attributes.categoryid = breadCrumb.catId;
                }
                if (breadCrumb.deptId) {
                    slotDetails.attributes.departmentid = breadCrumb.deptId;
                }
                if (breadCrumb.deptName) {
                    slotDetails.attributes.departmentname = breadCrumb.deptName;
                }
            });
        }

        const Recomendations = {
            certona: CertonaZone,
            adobe: CertonaZone,
        };
        const RecomendationsComponent =
            Recomendations[get(slotDetails, 'strategyProvider', 'certona')];

        return <>{RecomendationsComponent ? <RecomendationsComponent {...this.props} /> : null}</>;
    }
}

const mapStateToProps = (state) => ({
    taxonomyData: state.taxonomyData,
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...productCartridgeActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertonaZoneIris);
